import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight } from 'react-icons/fa';
import '../styles/AboutSection.css';

const features = [
  'Customized recruitment strategy tailored to your needs',
  'Industry expertise across healthcare and professional sectors',
  'Dedicated recruiters committed to your success',
  'Advanced social media and digital recruitment expertise',
  'Nationwide coverage with global reach'
];

const AboutSection = () => {
  return (
    <section className="about-section">
      <div className="container">
        <div className="about-grid">
          <div className="about-image">
            <div className="image-wrapper">
              <img
                src="/images/about-jwcs.jpg"
                alt="Team collaboration and professional growth"
                className="about-img"
              />
            </div>
            {/* 
            <div className="image-wrapper">
              <img
                src="/images/jwcs-logo-2.jpeg"
                alt="Joy Worldwide Consultancy Services Logo"
                className="about-img about-logo"
              />
            </div>
            <div className="about-secondary-images">
              <img
                src="https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
                alt="Professional woman celebrating career success"
                className="about-img-secondary"
              />
              <img
                src="https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
                alt="Confident professional in business attire"
                className="about-img-secondary"
              />
            </div>
            */}
          </div>

          <div className="about-content">
            <span className="section-tag">About JWCS</span>
            <h2 className="section-title">Why Choose Joy Worldwide Consultancy Services?</h2>
            <p className="about-text">
              JOY WORLDWIDE CONSULTANCY SERVICES
              has established itself as a trusted partner for businesses seeking exceptional talent.
              We understand that every organization has unique needs, and we pride ourselves on delivering
              customized solutions that drive success.
            </p>
            <p className="about-text">
              Our team of dedicated recruiters combines industry expertise with innovative recruitment
              strategies to connect you with the best candidates in the market.
            </p>

            <ul className="features-list">
              {features.map((feature, index) => (
                <li key={index}>
                  <FaCheckCircle className="check-icon" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>

            <Link to="/about" className="btn btn-primary">
              Learn More About Us <FaArrowRight className="btn-icon" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
